import React, {Component} from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import AppBar from 'material-ui/AppBar';
import Avatar from 'material-ui/Avatar';
import Drawer from 'material-ui/Drawer';
import MenuItem from 'material-ui/MenuItem';

class Header extends Component {

    constructor(props) {
        super(props);
        this.state = {open: false};
    }

    handleToggle = () => this.setState({open: !this.state.open});
    handleClose = () => this.setState({open: false});

    onLeftIconButtonTouchTap = () => { return; };

    search = (e, newValue) => {
        this.props.store.dispatch({type: 'SET_TERM', term: newValue});
    };

    logout = () => {
        this.handleToggle();
        this.props.auth.logout();
    };

    render() {
        
        return (
            <MuiThemeProvider>
                <AppBar
                    title={<span className="title">men·tor an experienced and trusted adviser</span>}
                    showMenuIconButton={false}
                    onLeftIconButtonTouchTap={this.onLeftIconButtonTouchTap} />
            </MuiThemeProvider>
        );
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.js